<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="row d-flex align-items-center">
          <div class="mr-auto col-12 col-sm-7">
            <h1 class="m-subheader__title" v-encode="pageTitle"></h1>
          </div>
          <div class="col-12 col-sm-5 d-flex">
            <span class="m-subheader__daterange mt-2 mt-md-0 ml-0 ml-sm-auto" id="m_dashboard_daterangepicker">
              <span class="m-subheader__daterange-label">
                <span class="m-subheader__daterange-title"></span>
                <span class="m-subheader__daterange-date m--font-info"></span>
              </span>
              <date-range-picker :opens="opens"
                                 :start-date="startDate"
                                 :end-date="endDate"
                                 @update="onDateRangeUpdate"></date-range-picker>
            </span>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content">
        <div class="m-portlet m-portlet--mobile">
          <div class="m-portlet__body">
            <timeline :items="operations" :component="timelineItem" :empty-text="emptyHistory"></timeline>
          </div>
        </div>
      </div>
    </div>
    <OperationOpinionModal></OperationOpinionModal>
  </page>
</template>

<script>
import DateRangePicker from '@/components/datepicker/DateRangePicker'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import Page from './Page';
import OperationOpinionModal from '@/components/modal/OperationOpinionModal';
import Timeline from '@/components/timeline/Timeline';
import PointsTimelineItem from '@/components/timeline/items/PointsTimelineItem';
import Screen from "@/mixins/screen";
import Encode from "@/directives/encode";
import BeforeRoute from "@/mixins/beforeRoute";
import PageTitle from "@/mixins/pageTitle";

export default {
  name: "PointsPage",
  components: {
    Timeline,
    OperationOpinionModal,
    Page,
    DateRangePicker,
    PointsTimelineItem,
  },
  mixins: [
    Screen,
    BeforeRoute('fetchOperations'),
    PageTitle('Punkty'),
  ],
  directives: {Encode},
  data() {
    return {
      timelineItem: PointsTimelineItem,
    }
  },
  mounted() {
    this.resetDates('points');
  },
  methods: {
    ...mapActions([
      'resetDates',
      'setPointsDates',
      'showOpinionModal',
    ]),
    onDateRangeUpdate(values) {
      this.setPointsDates({
        startDate: moment(values.startDate).format("YYYY-MM-DD"),
        endDate: moment(values.endDate).format("YYYY-MM-DD")
      })
    }
  },
  computed: {
    ...mapState({
      stateOperations: state => state.operations.operations,
      startDate: state => state.datePicker.dates.points.startDate,
      endDate: state => state.datePicker.dates.points.endDate,
      pointsConfig: state => state.settings.points,
      pagesConfig: state => state.navigation.pages,
      emptyHistory() {
        if (this.pointsConfig.name === '') {
          return this.$t('No points');
        }

        return this.$t('No data');
      },
      pageTitle() {
        return this.pagesConfig.filter((p) => p.to.name === 'PointsPage')[0].title;
      }
    }),
    operations() {
      return this.stateOperations.filter(
          (o) => moment(o.date).isSameOrAfter(`${this.startDate} 00:00:00`)
              && moment(o.date).isSameOrBefore(`${this.endDate} 23:59:59`)
      )
    },
    opens() {
      return this.windowWidth <= 575 ? 'center' : 'left';
    },
  }
}
</script>

<style scoped>

</style>
